// `machtfit.app.tracking/capture-event!`'s payload, reproduced key for key — the
// ClojureScript side carries a comment that changes to it are coordinated with the Data
// team, so the shape here is a copy and not a design.
//
// It lives in its own module because a second server-rendered page now needs it, and a
// copy per page is how the four keys drift apart from the ClojureScript original.

const LANGUAGES = ["de", "en"]

function language() {
  const lang = document.documentElement.lang
  return LANGUAGES.includes(lang) ? lang : "de"
}

export function captureUiEvent(name, uiId, properties) {
  if (typeof window.posthog === "undefined") {
    return
  }
  window.posthog.capture(`custom_${name}`, {
    event: { name, ...properties },
    language: language(),
    ui_id: uiId,
  })
}
